<template>
  <div class="away-message">
    <div class="away-message-bg"></div>
    <div class="away-message-wrapper">
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        @click="close"
        class="close-btn"
      />
      <span>
        You have unsaved changes made to this page which will be lost if you
        navigate away. Would you like to continue editing?
      </span>
      <div class="away-message-wrapper_action">
        <ActionButton
          :theme="scheme"
          class="mt-0 mr-2 w-auto"
          style="padding: 13px 20px;"
          label="Discard"
          @customEvent="proceed"
        />
        <ActionButton
          :theme="scheme"
          mode="outline"
          class="mt-0 w-auto"
          style="padding: 13px 20px;"
          label="Continue Editing"
          @customEvent="close"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
export default {
  name: "away-message",
  components: {
    ActionButton
  },
  props: {},
  methods: {
    close() {
      this.$emit("close");
    },
    proceed() {
      this.$emit("proceed");
    }
  },
  computed: {
    scheme() {
      return this.$store.state.app.scheme;
    }
  }
};
</script>

<style lang="scss" scoped>
.away-message {
  display: block;
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  &-bg {
    background: #000;
    content: "";
    opacity: 0.5;
    pointer-events: all;
    z-index: -1;
    height: 100%;
  }
  &-wrapper {
    animation: fade-in-up-data-v-5a453d14 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 60px 60px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 570px;
    z-index: 1;
    span {
      font-size: 18px;
    }
    &_action {
      padding-top: 30px;
      display: flex;
      justify-content: flex-end;
    }
    .close-btn {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 30px;
      right: 30px;
      z-index: 1;
    }
  }
}
</style>
